import { createSelector } from 'reselect';

const selectNewsState = () => (state) => state.get('news');

const selectorsGetNews = () =>
    createSelector(selectNewsState(), (substate) => substate.get('dataGetNews'));

const selectorsDeleteNews = () =>
    createSelector(selectNewsState(), (substate) => substate.get('dataDeleteNews'));

const selectorsPutNews = () =>
    createSelector(selectNewsState(), (substate) => substate.get('dataPutNews'));

const selectorsPostNews = () =>
    createSelector(selectNewsState(), (substate) => substate.get('dataPostNews'));

export { selectorsGetNews, selectorsDeleteNews, selectorsPutNews, selectorsPostNews };
